import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
  message?: string;
}

export function LoadingSpinner({ message }: LoadingSpinnerProps) {
  const { t } = useTranslation();

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="text-center py-20"
    >
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
        className="w-16 h-16 border-4 border-[#4F819F] border-t-transparent rounded-full mx-auto mb-6"
      ></motion.div>
      <h2 className="text-2xl font-bold text-slate-900 mb-2">
        {message || t('common.loading', 'Loading...')}
      </h2>
      <p className="text-slate-600">
        {t('common.pleaseWait', 'Please wait...')}
      </p>
    </motion.div>
  );
}
